/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * userAndPermissionApi API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseGroupListResponseItem,
  DashboardShareUserGroupResponse,
  DeleteV7UsersParams,
  GetV7GroupsParams,
  GetV7MeParams,
  GroupWithUsersAndAlertsResponse,
  PatchV7MeParams,
  PatchV7UsersParams,
  ResultResponse,
  RoleUserPermissionResponse,
  UpdateUserV7Request,
  UserResponse,
  UserV7Request,
  UserV7Response,
  UserWithGroupsAndRoleV7Response,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 유저 권한에 따라 그룹 목록을 조회하는 API
 */
export const getV7Groups = (
  params?: MaybeRef<GetV7GroupsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseGroupListResponseItem>(
    { url: `/api/v7/groups`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7GroupsQueryKey = (params?: MaybeRef<GetV7GroupsParams>) => {
  return ['api', 'v7', 'groups', ...(params ? [params] : [])] as const;
};

export const getGetV7GroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7Groups>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7GroupsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Groups>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7GroupsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7Groups>>> = ({ signal }) =>
    getV7Groups(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7Groups>>,
    TError,
    TData
  >;
};

export type GetV7GroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getV7Groups>>>;
export type GetV7GroupsQueryError = ErrorType<unknown>;

/**
 * @summary 유저 권한에 따라 그룹 목록을 조회하는 API
 */

export function useGetV7Groups<
  TData = Awaited<ReturnType<typeof getV7Groups>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7GroupsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Groups>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7GroupsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary group id로 그룹 정보를 조회하는 API
 */
export const getV7GroupsByGroupId = (
  groupId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  groupId = unref(groupId);

  return customAxiosInstance<GroupWithUsersAndAlertsResponse>(
    { url: `/api/v7/groups/${groupId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7GroupsByGroupIdQueryKey = (groupId?: MaybeRef<number>) => {
  return ['api', 'v7', 'groups', groupId] as const;
};

export const getGetV7GroupsByGroupIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7GroupsByGroupId>>,
  TError = ErrorType<unknown>,
>(
  groupId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7GroupsByGroupId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7GroupsByGroupIdQueryKey(groupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7GroupsByGroupId>>> = ({ signal }) =>
    getV7GroupsByGroupId(groupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(groupId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7GroupsByGroupId>>, TError, TData>;
};

export type GetV7GroupsByGroupIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7GroupsByGroupId>>
>;
export type GetV7GroupsByGroupIdQueryError = ErrorType<unknown>;

/**
 * @summary group id로 그룹 정보를 조회하는 API
 */

export function useGetV7GroupsByGroupId<
  TData = Awaited<ReturnType<typeof getV7GroupsByGroupId>>,
  TError = ErrorType<unknown>,
>(
  groupId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7GroupsByGroupId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7GroupsByGroupIdQueryOptions(groupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getMyInfo
 */
export const getV7Me = (
  params?: MaybeRef<GetV7MeParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<UserWithGroupsAndRoleV7Response>(
    { url: `/api/v7/me`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MeQueryKey = (params?: MaybeRef<GetV7MeParams>) => {
  return ['api', 'v7', 'me', ...(params ? [params] : [])] as const;
};

export const getGetV7MeQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7Me>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MeParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Me>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7Me>>> = ({ signal }) =>
    getV7Me(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7Me>>,
    TError,
    TData
  >;
};

export type GetV7MeQueryResult = NonNullable<Awaited<ReturnType<typeof getV7Me>>>;
export type GetV7MeQueryError = ErrorType<unknown>;

/**
 * @summary getMyInfo
 */

export function useGetV7Me<
  TData = Awaited<ReturnType<typeof getV7Me>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MeParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Me>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary patchMyInfo
 */
export const patchV7Me = (
  updateUserV7Request: MaybeRef<UpdateUserV7Request>,
  params?: MaybeRef<PatchV7MeParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  updateUserV7Request = unref(updateUserV7Request);
  params = unref(params);

  return customAxiosInstance<UserResponse>(
    {
      url: `/api/v7/me`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserV7Request,
      params: unref(params),
    },
    options,
  );
};

export const getPatchV7MeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7Me>>,
    TError,
    { data: BodyType<UpdateUserV7Request>; params?: PatchV7MeParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7Me>>,
  TError,
  { data: BodyType<UpdateUserV7Request>; params?: PatchV7MeParams },
  TContext
> => {
  const mutationKey = ['patchV7Me'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7Me>>,
    { data: BodyType<UpdateUserV7Request>; params?: PatchV7MeParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return patchV7Me(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7MeMutationResult = NonNullable<Awaited<ReturnType<typeof patchV7Me>>>;
export type PatchV7MeMutationBody = BodyType<UpdateUserV7Request>;
export type PatchV7MeMutationError = ErrorType<unknown>;

/**
 * @summary patchMyInfo
 */
export const usePatchV7Me = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7Me>>,
      TError,
      { data: BodyType<UpdateUserV7Request>; params?: PatchV7MeParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7Me>>,
  TError,
  { data: BodyType<UpdateUserV7Request>; params?: PatchV7MeParams },
  TContext
> => {
  const mutationOptions = getPatchV7MeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getGroupsInfo
 */
export const getV7OpenInfoGroupsInfo = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<DashboardShareUserGroupResponse>(
    { url: `/api/v7/open-info/groups-info`, method: 'GET', signal },
    options,
  );
};

export const getGetV7OpenInfoGroupsInfoQueryKey = () => {
  return ['api', 'v7', 'open-info', 'groups-info'] as const;
};

export const getGetV7OpenInfoGroupsInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OpenInfoGroupsInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV7OpenInfoGroupsInfo>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OpenInfoGroupsInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OpenInfoGroupsInfo>>> = ({
    signal,
  }) => getV7OpenInfoGroupsInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OpenInfoGroupsInfo>>,
    TError,
    TData
  >;
};

export type GetV7OpenInfoGroupsInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OpenInfoGroupsInfo>>
>;
export type GetV7OpenInfoGroupsInfoQueryError = ErrorType<unknown>;

/**
 * @summary getGroupsInfo
 */

export function useGetV7OpenInfoGroupsInfo<
  TData = Awaited<ReturnType<typeof getV7OpenInfoGroupsInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OpenInfoGroupsInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OpenInfoGroupsInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getPermissionUserRoles
 */
export const getV7UserRoles = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<RoleUserPermissionResponse>(
    { url: `/api/v7/user-roles`, method: 'GET', signal },
    options,
  );
};

export const getGetV7UserRolesQueryKey = () => {
  return ['api', 'v7', 'user-roles'] as const;
};

export const getGetV7UserRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7UserRoles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7UserRoles>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7UserRolesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7UserRoles>>> = ({ signal }) =>
    getV7UserRoles(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7UserRoles>>,
    TError,
    TData
  >;
};

export type GetV7UserRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getV7UserRoles>>>;
export type GetV7UserRolesQueryError = ErrorType<unknown>;

/**
 * @summary getPermissionUserRoles
 */

export function useGetV7UserRoles<
  TData = Awaited<ReturnType<typeof getV7UserRoles>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7UserRoles>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7UserRolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary deleteV7User
 */
export const deleteV7Users = (
  params: MaybeRef<DeleteV7UsersParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    { url: `/api/v7/users`, method: 'DELETE', params: unref(params) },
    options,
  );
};

export const getDeleteV7UsersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV7Users>>,
    TError,
    { params: DeleteV7UsersParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV7Users>>,
  TError,
  { params: DeleteV7UsersParams },
  TContext
> => {
  const mutationKey = ['deleteV7Users'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV7Users>>,
    { params: DeleteV7UsersParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteV7Users(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV7UsersMutationResult = NonNullable<Awaited<ReturnType<typeof deleteV7Users>>>;

export type DeleteV7UsersMutationError = ErrorType<unknown>;

/**
 * @summary deleteV7User
 */
export const useDeleteV7Users = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV7Users>>,
      TError,
      { params: DeleteV7UsersParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV7Users>>,
  TError,
  { params: DeleteV7UsersParams },
  TContext
> => {
  const mutationOptions = getDeleteV7UsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 사용자 정보 수정
 */
export const patchV7Users = (
  userV7Request: MaybeRef<UserV7Request>,
  params?: MaybeRef<PatchV7UsersParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  userV7Request = unref(userV7Request);
  params = unref(params);

  return customAxiosInstance<UserV7Response>(
    {
      url: `/api/v7/users`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: userV7Request,
      params: unref(params),
    },
    options,
  );
};

export const getPatchV7UsersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7Users>>,
    TError,
    { data: BodyType<UserV7Request>; params?: PatchV7UsersParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7Users>>,
  TError,
  { data: BodyType<UserV7Request>; params?: PatchV7UsersParams },
  TContext
> => {
  const mutationKey = ['patchV7Users'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7Users>>,
    { data: BodyType<UserV7Request>; params?: PatchV7UsersParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return patchV7Users(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7UsersMutationResult = NonNullable<Awaited<ReturnType<typeof patchV7Users>>>;
export type PatchV7UsersMutationBody = BodyType<UserV7Request>;
export type PatchV7UsersMutationError = ErrorType<unknown>;

/**
 * @summary 사용자 정보 수정
 */
export const usePatchV7Users = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7Users>>,
      TError,
      { data: BodyType<UserV7Request>; params?: PatchV7UsersParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7Users>>,
  TError,
  { data: BodyType<UserV7Request>; params?: PatchV7UsersParams },
  TContext
> => {
  const mutationOptions = getPatchV7UsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
